import React from 'react'
import injectSheet from 'react-jss'
import styles from './back-button.styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft'
import classNames from 'classnames'

const BackButton = ({ classes, children, bottomMargin, ...props }) => (
  <span
    {...props}
    role="button"
    className={classNames(classes.backButton, {
      [classes.bottomMargin]: bottomMargin
    })}>
    <FontAwesomeIcon className={classes.backIcon} icon={faCaretLeft} />
    {children}
  </span>
)

export default injectSheet(styles)(BackButton)
